export enum TableQueryParams {
  Sorts = "sorts",
}
